export default function Hero() {
  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(https://static.readdy.ai/image/4f1580f9373e811b39bfa09d083e9beb/e09efb431d6da5ca5f3fe1d2395e6a47.png)'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full py-20">
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
          Master <strong>Facebook Marketing</strong> in 2026
        </h1>
        <p className="text-xl md:text-2xl text-white/95 mb-8 max-w-3xl mx-auto leading-relaxed">
          Transform your business with proven <strong>Facebook Marketing</strong> strategies. Learn how to create high-converting ads, build engaged communities, and maximize your ROI with expert <strong>social media advertising</strong> techniques.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
          <a
            href="https://payhip.com/b/8JEKZ"
            target="_blank"
            rel="noopener noreferrer"
            className="px-8 py-4 bg-gradient-to-r from-blue-600 to-blue-500 text-white text-lg font-bold rounded-full hover:shadow-2xl hover:scale-105 transition-all cursor-pointer whitespace-nowrap"
          >
            Start Your Journey
          </a>
          <a
            href="https://youtu.be/cHCItniebqw?si=Teame1vNbtACwowo"
            target="_blank"
            rel="noopener noreferrer"
            className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white text-lg font-semibold rounded-full border-2 border-white/30 hover:bg-white/20 transition-all cursor-pointer whitespace-nowrap"
          >
            Watch Video
          </a>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16 max-w-5xl mx-auto">
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 border border-white/20">
            <div className="w-16 h-16 flex items-center justify-center bg-blue-500/20 rounded-full mb-4 mx-auto">
              <i className="ri-line-chart-line text-3xl text-blue-300"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-3">Proven Strategies</h3>
            <p className="text-white/80 text-sm leading-relaxed">
              Learn battle-tested <strong>Facebook Marketing</strong> techniques that deliver real results and sustainable growth for your business.
            </p>
          </div>
          
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 border border-white/20">
            <div className="w-16 h-16 flex items-center justify-center bg-blue-400/20 rounded-full mb-4 mx-auto">
              <i className="ri-team-line text-3xl text-blue-200"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-3">Expert Guidance</h3>
            <p className="text-white/80 text-sm leading-relaxed">
              Get personalized support from <strong>social media advertising</strong> experts who understand your unique business challenges.
            </p>
          </div>
          
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 border border-white/20">
            <div className="w-16 h-16 flex items-center justify-center bg-blue-300/20 rounded-full mb-4 mx-auto">
              <i className="ri-rocket-line text-3xl text-blue-100"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-3">Fast Results</h3>
            <p className="text-white/80 text-sm leading-relaxed">
              Start seeing improvements in your <strong>Facebook Marketing</strong> campaigns within weeks, not months.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}